import { lazy, Suspense } from "react"

import { Flex } from "@/atoms"

const LanguageIcon = lazy(() =>
  import("./LanguageIcon").catch(() => ({ default: () => null }))
)

export const LanguageItem = (props: {
  label?: string
  lng?: Settings.Language
}) => {
  if (!props.lng || !props.label) return null

  return (
    <Flex gap={8} align="center">
      <Suspense fallback={props.label}>
        <LanguageIcon lng={props.lng} />
        {props.label}
      </Suspense>
    </Flex>
  )
}
